import { FunctionComponent } from 'react';
import { Typography } from '../../tailwindcomponents';
import { Button } from '../../tailwindcomponents';
import { CheckCircle, RemoveCircle } from '../../components/icons';
import { Request } from '../../types/capabilityList';

interface PermissionsProps {
    request: Request,
    viewMode: boolean,
    setRequest: Function,
}

const Permissions: FunctionComponent<PermissionsProps> = ({ request, setRequest, viewMode }) => {

    const onUpdateBooleanFields = (field: keyof Request, value: boolean) => {
        setRequest((prevState: Request) => ({
            ...prevState,
            [field]: !value,
        }));
    };

    return (
        <div className="mt-4">
            <div className="w-full"><Typography color='primary' variant='h2' text={"Permissions"} align='center' /></div>
            <div className="flex flex-wrap justify-center items-start gap-8">
                <div className="flex flex-col items-center">
                    <Typography text={"Inspect Tested"} align='center' />
                    <Button variant="text" disabled={viewMode} onClick={() => { onUpdateBooleanFields("is_inspection_test", request.is_inspection_test) }}>
                        {request.is_inspection_test
                            ? <CheckCircle color='success' />
                            : <RemoveCircle color="error" />}
                    </Button>
                </div>
                <div className="flex flex-col items-center">
                    <Typography text={"OH"} align='center' />
                    <Button variant="text" disabled={viewMode} onClick={() => { onUpdateBooleanFields("is_oh", request.is_oh) }}>
                        {request.is_oh
                            ? <CheckCircle color='success' />
                            : <RemoveCircle color="error" />}
                    </Button>
                </div>
                <div className="flex flex-col items-center">
                    <Typography text={"MOD'S"} align='center' />
                    <Button variant="text" disabled={viewMode} onClick={() => { onUpdateBooleanFields("is_mods", request.is_mods) }}>
                        {request.is_mods
                            ? <CheckCircle color='success' />
                            : <RemoveCircle color="error" />}
                    </Button>
                </div>
                <div className="flex flex-col items-center">
                    <Typography text={"Repair"} align='center' />
                    <Button variant="text" disabled={viewMode} onClick={() => { onUpdateBooleanFields("is_repair", request.is_repair) }}>
                        {request.is_repair
                            ? <CheckCircle color='success' />
                            : <RemoveCircle color="error" />}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default Permissions;